// import logo from './logo.svg';
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import "./App.css";  
import Home from "./pages/home/Home"; 
import HeaderTop from "./Header";
import Footer from "./Footer"; 
import CmsPage from "./pages/CmsPage";   
import BlogAll from "./pages/BlogAll"; 
import BlogDetails from "./pages/BlogDetails";
function App() {
  return (
      // basename="/blog/"
    <Router>
    <HeaderTop/>
      <Routes>
        <Route path="/" element={<Home />} />  
        <Route path="/:slug" element={<CmsPage key={window.location.pathname} />} /> 
        <Route path="/blog" element={<BlogAll />} />  
        <Route path="/:categorySlug/:slug" element={<BlogDetails />} />    
        
        {/* <Route path="/blogs/:slug" element={<BlogDetails />} /> */}

      </Routes>
      <Footer />
    </Router>
  );
}

export default App;
